import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import Table from '../Table/Table'
import TableControls from 'components/Table/TableControls'
import DocumentIcon from '@tecuity/sos-icons/react/document'
import { Body } from '../Shell/Shell'
import { Spinner } from '../Loaders/Loaders'
import { PageError } from '../PageError/PageError'
import {
  pullAndSetMyRecords,
  selectMyRecordsRow,
  selectMyRecordsRowAndGetDetails,
  setActiveCategory,
  getMyRecordsDescription,
  setFilters,
  setMyRecordsResultsMode,
} from './MyRecordsActions'
import { getOrderedResultsByCategory } from 'utilities'
import RecordDrawer from 'components/RecordDrawer/RecordDrawer'
import EmptyBox from './EmptyBox'
import './MyRecords.scss'
import { SUBROUTES_OBJ } from '../../App'
import * as api from '../../requests'

const MY_RECORDS_DISABLE_EMPTY_STATE = process.env.MY_RECORDS_DISABLE_EMPTY_STATE
const MY_RECORDS_EMPTY_STATE_LINE_1 = process.env.MY_RECORDS_EMPTY_STATE_LINE_1
const MY_RECORDS_EMPTY_STATE_LINE_2 = process.env.MY_RECORDS_EMPTY_STATE_LINE_2
const MY_RECORDS_SEARCH_PLACEHOLDER = process.env.MY_RECORDS_SEARCH_PLACEHOLDER
const MY_RECORDS_DESCRIPTION = process.env.MY_RECORDS_DESCRIPTION

class MyRecords extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ownershipModalOpen: false,
      amendmentLauncherOpen: false,
      reinstatementModelOpen: false,
    }
  }
  componentDidMount = () => {
    if (this.props.match.params.subParam) {
      if (
        !SUBROUTES_OBJ[this.props.match.params.subParam] ||
        !(SUBROUTES_OBJ[this.props.match.params.subParam].allowedRoutes || ['/records/']).includes(
          '/records/'
        )
      ) {
        this.props.history.replace(
          `/records/${this.props.sublinks.find((x) =>
            (x.allowedRoutes || ['/records/']).includes('/records/')
          ).parameter
          }`
        )
      } else {
        this.props.setActiveCategory(this.props.match.params.subParam)
        this.getRecords()
        if (SUBROUTES_OBJ[this.props.match.params.subParam].serverMyRecordsDescription
          && !this.props.serverDescription
        ) {
          this.props.getMyRecordsDescription(this.props.match.params.subParam)
        }
      }
    }
  }
  componentDidUpdate = (prevProps) => {
    const module = window.location.href.split('/').pop()
    if (module !== this.state.module)
      this.setState((state) => (state = { ...state, module: module }))
    if (this.props.match.params.subParam !== prevProps.match.params.subParam) {
      if (
        SUBROUTES_OBJ[this.props.match.params.subParam] &&
        (SUBROUTES_OBJ[this.props.match.params.subParam].allowedRoutes || ['/records/']).includes(
          '/records/'
        )
      ) {
        this.props.setActiveCategory(this.props.match.params.subParam)
        this.getRecords(this.props.match.params.subParam)
      } else {
        this.props.history.replace(
          `/records/${this.props.sublinks.find(
            (x) =>
              (x.allowedRoutes || ['/records/']).includes('/records/')
          ).parameter
          }`
        )
      }
    }
  }
  getRecords = (nextCategory) => {
    this.props.pullAndSetMyRecords(
      nextCategory || this.props.match.params.subParam || this.props.sublinks[0].parameter
    )
  }
  onBodyResize = ({ width, height }) => {
    if (width < 500 && this.props.resultsMode === 'table') {
      this.props.setMyRecordsResultsMode('cards')
    } else if (width >= 500 && this.props.resultsMode === 'cards') {
      this.props.setMyRecordsResultsMode('table')
    }
  }
  selectRow = (row) => {
    this.props.selectMyRecordsRowAndGetDetails(
      this.props.match.params.subParam,
      this.props.selectedId === row.ID ? null : row.ID
    )
  }
  formatForCards = (template, rows) => {
    let cards = rows.map((row, i) => ({
      title: row[template[0].id],
      alert: row.ALERT_YN,
      details: this.formatRowDetails(template.slice(1), row),
      recordId: row.RECORD_ID,
      data: row,
    }))
    return cards
  }
  clearSelection = () => {
    this.props.selectMyRecordsRow(this.props.match.params.subParam, null)
  }
  closeOwnershipModalAndRefreshRecords = () => {
    this.ownershipModal.closeModal()
    this.getRecords()
  }
  setFilters = (filters, props = {}) => {
    this.props.setFilters(this.props.match.params.subParam, filters)
    if (props.getRecords !== false) {
      this.getRecords()
    }
  }

  getLowercaseSublinkLabel = (sublink) =>
    sublink.preserveCasing ? sublink.label || '' : (sublink.label || '').toLowerCase()

  getMergedEmptyStateText = (text, sublink) =>
    text.replace(/{{CATEGORY}}/g, this.getLowercaseSublinkLabel(sublink))

  renderEmptyResults(props, sublink) {
    const renderEmpty =
      !MY_RECORDS_DISABLE_EMPTY_STATE &&
      !props.loading &&
      props.orderedRecords &&
      !props.orderedRecords.rows.length

    if (renderEmpty) {
      let line1 = `Looks like you don't have any ${this.getLowercaseSublinkLabel(
        sublink
      )} records yet`
      let line2 = `Visit ${this.getLowercaseSublinkLabel(
        sublink
      )} forms to create your first record`
      if (MY_RECORDS_EMPTY_STATE_LINE_1) {
        line1 = this.getMergedEmptyStateText(MY_RECORDS_EMPTY_STATE_LINE_1, sublink)
      }
      if (MY_RECORDS_EMPTY_STATE_LINE_2) {
        line2 = this.getMergedEmptyStateText(MY_RECORDS_EMPTY_STATE_LINE_2, sublink)
      }
      return (
        <div className="empty-placeholder-wrapper">
          <EmptyBox />
          <h2>{line1}</h2>
          <p>{line2}</p>
          <div className="flex-row center">
            <Link className="btn btn-primary btn-raised" to={`/forms/${sublink.parameter}`}>
              Go to {this.getLowercaseSublinkLabel(sublink)} forms
            </Link>
            <p className="or">or</p>
            <Link className="btn btn-neutral" to={`/search/${sublink.parameter}`}>
              Search {this.getLowercaseSublinkLabel(sublink)} records
            </Link>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  renderPageData(props) {
    if (props.error) {
      return <PageError errorDetails={props.errorDetails} />
    } else if (!props.orderedRecords) {
      return <Spinner className="page-loader" />
    } else {
      const actionMap = {
        default: [
          {
            iconClass: '',
            label: 'View Filing',
            className: 'primary',
            onClick: this.selectRow,
            children: <DocumentIcon />,
          },
        ],
      }
      return (
        <div className="table-wrapper">
          {props.orderedRecords.rows && props.orderedRecords.rows.length > 0 && (
            <Table
              label="My Records"
              template={props.orderedRecords.template}
              rows={props.orderedRecords.rows}
              className="center-container"
              actionMap={actionMap}
              actionCell={true}
              onCellClick={this.selectRow}
              selectedRowIndex={
                props.orderedRecords.rows
                  ? props.orderedRecords.rows.findIndex((row) => row.ID === props.selectedId)
                  : false
              }
              animated={false}
              rowCount
            />
          )}
        </div>
      )
    }
  }

  render() {
    const {
      // resultsMode = 'table',
      loading,
      records,
      selectedId,
      showSelected,
      activeCategory,
      sublinks,
      serverDescription,
      filters,
      isMobile,
    } = this.props
    const category = this.props.match.params.subParam
    const selectedRecord = records[selectedId]
    const selectedTitle = selectedRecord ? selectedRecord.TITLE[0] : ''
    const selectedSubtitle = selectedRecord ? selectedRecord.TITLE[1] : ''
    const sublink = sublinks.find((l) => l.parameter === category) || {}
    const activeFilters = filters[category] || {}

    return (
      <Body
        className="my-records"
        showDrawer={showSelected}
        onResize={this.onBodyResize}
      >
        <h1 className="page-title">My {sublink.label} Records</h1>
        {!this.props.match.params.subParam && (
          <Redirect
            to={`${this.props.location.pathname}/${activeCategory ? activeCategory : this.props.sublinks[0].parameter
              }`}
          />
        )}
        <TableControls
          description={serverDescription || sublink.myRecordsDescription || MY_RECORDS_DESCRIPTION || ''}
          filterTemplates={sublink.myRecordsFilters}
          filters={activeFilters}
          onFilterChange={this.setFilters}
          allowSearch={sublink.myRecordsSearch !== false}
          loading={loading}
          searchPlaceholder={MY_RECORDS_SEARCH_PLACEHOLDER || 'Search My Records'}
        />

        {this.renderPageData(this.props)}

        {this.renderEmptyResults(this.props, sublink)}

        <RecordDrawer
          show={isMobile ? (selectedId ? true : false) : showSelected}
          title={selectedTitle}
          subtitle={selectedSubtitle}
          category={category}
          sourceId={selectedRecord && selectedRecord.ID}
          recordNum={selectedRecord && selectedRecord.RECORD_NUM}
          canFileAR={selectedRecord && selectedRecord.CAN_FILE_AR}
          canReinstate={selectedRecord && selectedRecord.CAN_REINSTATE}
          canFileReinstatement={selectedRecord && selectedRecord.CAN_FILE_REINSTATEMENT}
          showCopyRequests={selectedRecord && selectedRecord.SHOW_COPY_REQUESTS}
          userOwnsCurrentRecord={process.env.USER_ACCESS_LEVEL_MANAGEMENT ? false : true}
          canAlwaysFileAR={selectedRecord && selectedRecord.CAN_ALWAYS_FILE_AR}
          onRequestRecordsRefresh={this.getRecords}
          sublink={sublink}
          onSidebarDismiss={this.clearSelection}
        />
      </Body>
    )
  }
}
MyRecords = connect(
  (state, props) => ({
    orderedRecords:
      props.match.params.subParam && state.myRecords.results
        ? getOrderedResultsByCategory(
          props.match.params.subParam,
          state.myRecords.results,
          state.myRecords.templates
        )
        : null,
    records:
      props.match.params.subParam && state.myRecords.results
        ? state.myRecords.results[props.match.params.subParam]
          ? state.myRecords.results[props.match.params.subParam]
          : {}
        : {},
    resultsMode: state.myRecords.resultsMode,
    loading: state.myRecords.loading,
    selectedId: props.match.params.subParam
      ? state.myRecords.selected[props.match.params.subParam]
      : null,
    showSelected: state.myRecords.showSelected,
    selectedDetails: state.myRecords.selectedDetails,
    isMobile: state.app.isMobile,
    recordDetailsLoading: state.myRecords.recordDetailsLoading,
    activeCategory: state.myRecords.activeCategory || state.app.currentCategory,
    filters: state.myRecords.filters,
    error: state.myRecords.error,
    errorDetails: state.myRecords.errorDetails,
    serverDescription:
      (props.match.params.subParam && state.myRecords.descriptions[props.match.params.subParam]) || '',
  }),
  {
    pullAndSetMyRecords,
    setMyRecordsResultsMode,
    selectMyRecordsRowAndGetDetails,
    selectMyRecordsRow,
    setActiveCategory,
    setFilters,
    getMyRecordsDescription
  }
)(MyRecords)

export default MyRecords



// WEBPACK FOOTER //
// ./src/components/MyRecords/MyRecords.js